
<template>
    <nav v-if="!client">

       <ul class="pagination pagination-sm m-0 float-right d-flex align-items-center">
        <span v-if="pagination.from" class="page-stats pr-3">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
       
       <li class="page-item" v-if="pagination.prevPageUrl">
        <a  class="page-link" @click="$emit('prev');">
            Prev
        </a>
       </li>
       
       <li class="page-item" v-else :disabled="true">
        <a class="page-link" >
           Prev
        </a>
       </li>

<li class="page-item" v-if="pagination.nextPageUrl">
        <a class="page-link" @click="$emit('next');">
            Next
        </a>
</li>
 <li class="page-item" v-else :disabled="true">
        <a class="page-link" >
            Next
        </a>
 </li>
        </ul>
    </nav>

</template>

<script>
    export default {
        props: ['pagination', 'client', 'filtered']
    }
</script>

<style scoped>
.page-link{
    cursor: pointer !important
}
</style>